<template>
  <BbPopup v-model="isOpened" :showCloseIcon="true" contentClass="share-conversation-dialog">
    <template #popup-header>
      <TextBody i18n-key="conversation.shareConversation" tag="span" :body-type="2" weight="medium" />
    </template>
    <div class="share-link-actions">
      <TextBody :text="shareLabel" tag="span" :body-type="1" weight="medium" />
      <BbInput :model-value="sharedLink" readonly />
      <BbBtn size="small" type="secondary" :disabled="!sharedLink" @click="copyToClipboard">
        <BbIcon size="small" name="links" />
        <TextBody i18n-key="common.copyLink" />
      </BbBtn>
    </div>
  </BbPopup>
</template>
<script>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { Routes } from '~/constants/routes';
import TextBody from '~/components/common/TextBody.vue';

export default {
  components: { TextBody },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    conversation: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { t } = useI18n();

    const isOpened = computed({
      get: () => props.modelValue,
      set: (val) => emit('update:modelValue', val),
    });

    const title = computed(() => props.conversation?.title || t('conversation.conversation'));
    const shareLabel = computed(() => t('conversation.shareConversationLabel', { title: title.value }));

    const sharedLink = computed(() =>
      props.conversation?.conversationId
        ? `${window.location.origin}${Routes.Conversation.pathWithoutParam}/${props.conversation.conversationId}`
        : '',
    );

    const copyToClipboard = async () => {
      try {
        await navigator.clipboard.writeText(sharedLink.value);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    };

    return {
      isOpened,
      shareLabel,
      sharedLink,
      copyToClipboard,
    };
  },
};
</script>
<style scoped lang="scss">
.share-link-actions {
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-3;
}
</style>
